<template>
    <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/store/auth'

const auth = useAuthStore()

onMounted(() => {
  auth.checkAuth()
})
</script>

<style>
.parent::-webkit-scrollbar {
  width: 0%;
  height: 0%;
}
</style>
